import { TypeFromSchemaValidator } from "../schema-validator";
import { handleApiError } from "../errors";
import { ApiClient, ApiClientConfig } from "../api-client";
import instituteSchemaValidators from "../institute/schema-validators";
import schemaValidators from "./schema-validators";

type VerityInstituteSettings = TypeFromSchemaValidator<(typeof instituteSchemaValidators)["verityInstituteSettings"]>;

export default class AdminClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClientConfig) {
		super(config, schemaValidators);
	}

	updateVerityInstituteSettings = async (instituteId: number, settings: Partial<VerityInstituteSettings>) => {
		return await handleApiError(
			super.fetch(new URL(`/api/verity/lti-institute/${instituteId}/settings`, this.config.verityOrigin), {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(settings),
				credentials: "include",
			}),
		);
	};
}
